// Cache busting utilities for production
export const generateCacheBuster = (): string => {
  return Date.now().toString();
};

export const addCacheBusterToUrl = (url: string): string => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}_cb=${generateCacheBuster()}`;
};

export const getCacheBustingHeaders = () => ({
  "Cache-Control": "no-cache, no-store, must-revalidate",
  Pragma: "no-cache",
  Expires: "0",
});

// Force page reload with cache bypass
export const forceHardReload = (): void => {
  if (window.location.hostname === "localhost") {
    return;
  }

  window.location.reload();
};

// Clear all browser caches (if supported)
export const clearAllCaches = async (): Promise<void> => {
  try {
    // Clear service worker caches
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map((cacheName) => caches.delete(cacheName))
      );
    }

    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();
  } catch (error) {
    // Error clearing caches
  }
};
